import { render, staticRenderFns } from "./create.template.pug?vue&type=template&id=0ffa10db&lang=pug&"
import script from "./create.script.js?vue&type=script&lang=js&"
export * from "./create.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "index.vue"
export default component.exports